<template>
  <div class="merchant-audit">
    <el-card shadow="never">
      <!-- 筛选栏 -->
      <div class="filter-bar">
        <span class="filter-label">审核状态：</span>
        <el-radio-group v-model="filterStatus" size="small" @change="fetchList">
          <el-radio-button label="">全部</el-radio-button>
          <el-radio-button label="0">待审核</el-radio-button>
          <el-radio-button label="1">已通过</el-radio-button>
          <el-radio-button label="2">已驳回</el-radio-button>
        </el-radio-group>
      </div>

      <el-table :data="list" border stripe v-loading="loading" style="width: 100%">
        <el-table-column prop="id" label="ID" width="70" />
        <el-table-column prop="member_nickname" label="会员昵称" min-width="140" />
        <el-table-column prop="member_phone" label="手机号" width="130" />
        <el-table-column prop="status" label="审核状态" width="100">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.status === 0" type="warning">待审核</el-tag>
            <el-tag v-else-if="scope.row.status === 1" type="success">已通过</el-tag>
            <el-tag v-else-if="scope.row.status === 2" type="danger">已驳回</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="created_at" label="申请时间" width="170" />
        <el-table-column label="操作" width="100" fixed="right">
          <template slot-scope="scope">
            <el-button type="text" @click="handleDetail(scope.row)">查看详情</el-button>
          </template>
        </el-table-column>
      </el-table>

      <div class="pagination-wrap">
        <el-pagination
          background
          layout="total, prev, pager, next"
          :total="total"
          :page-size="pageSize"
          :current-page.sync="page"
          @current-change="fetchList"
        />
      </div>
    </el-card>

    <!-- 详情弹窗 -->
    <el-dialog title="商户审核详情" :visible.sync="detailVisible" width="700px" top="5vh">
      <div class="detail-content">
        <!-- 会员信息 -->
        <el-divider content-position="left">会员信息</el-divider>
        <el-form label-width="100px" size="small">
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="会员昵称">{{ detail.member_nickname }}</el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="手机号">{{ detail.member_phone }}</el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="会员ID">{{ detail.member_id }}</el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="申请时间">{{ detail.created_at }}</el-form-item>
            </el-col>
          </el-row>
        </el-form>

        <!-- 证照信息 -->
        <el-divider content-position="left">证照信息</el-divider>
        <el-form label-width="100px" size="small">
          <el-form-item label="营业执照">
            <div v-if="detail.business_license" class="image-row">
              <el-image
                :src="detail.business_license"
                style="width: 300px; height: 200px"
                fit="contain"
                :preview-src-list="[detail.business_license]"
              />
              <el-button type="text" icon="el-icon-download" @click="downloadImage(detail.business_license, '营业执照')">下载</el-button>
            </div>
            <span v-else class="no-data">未上传</span>
          </el-form-item>
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="身份证正面">
                <div v-if="detail.legal_person_front" class="image-row">
                  <el-image
                    :src="detail.legal_person_front"
                    style="width: 200px; height: 130px"
                    fit="contain"
                    :preview-src-list="[detail.legal_person_front]"
                  />
                  <el-button type="text" icon="el-icon-download" @click="downloadImage(detail.legal_person_front, '身份证正面')">下载</el-button>
                </div>
                <span v-else class="no-data">未上传</span>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="身份证反面">
                <div v-if="detail.legal_person_back" class="image-row">
                  <el-image
                    :src="detail.legal_person_back"
                    style="width: 200px; height: 130px"
                    fit="contain"
                    :preview-src-list="[detail.legal_person_back]"
                  />
                  <el-button type="text" icon="el-icon-download" @click="downloadImage(detail.legal_person_back, '身份证反面')">下载</el-button>
                </div>
                <span v-else class="no-data">未上传</span>
              </el-form-item>
            </el-col>
          </el-row>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>

        <!-- 公户卡信息 -->
        <el-divider content-position="left">公户卡信息</el-divider>
        <el-form label-width="100px" size="small">
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="银行卡号">{{ detail.bank_card_no || '未填写' }}</el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="开户行">{{ detail.bank_name || '未填写' }}</el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="开户省">{{ detail.bank_province || '未填写' }}</el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="开户市">{{ detail.bank_city || '未填写' }}</el-form-item>
            </el-col>
          </el-row>
        </el-form>

        <!-- 审核操作 -->
        <el-divider content-position="left">审核操作</el-divider>
        <el-form label-width="100px" size="small">
          <el-form-item label="审核状态">
            <el-tag v-if="detail.status === 0" type="warning">待审核</el-tag>
            <el-tag v-else-if="detail.status === 1" type="success">已通过</el-tag>
            <el-tag v-else-if="detail.status === 2" type="danger">已驳回</el-tag>
          </el-form-item>

          <!-- 已通过的商户信息 -->
          <template v-if="detail.status === 1">
            <el-form-item label="商户号">{{ detail.wechat_merchant_no || '-' }}</el-form-item>
            <el-form-item label="商户密钥">{{ detail.wechat_merchant_secret || '-' }}</el-form-item>
            <el-form-item label="审核时间">{{ detail.audited_at || '-' }}</el-form-item>
          </template>

          <!-- 已驳回 -->
          <template v-if="detail.status === 2">
            <el-form-item label="驳回原因">{{ detail.reject_reason || '-' }}</el-form-item>
            <el-form-item label="审核时间">{{ detail.audited_at || '-' }}</el-form-item>
          </template>

          <!-- 待审核时显示操作区域 -->
          <template v-if="detail.status === 0">
            <el-divider />
            <div class="audit-actions">
              <el-radio-group v-model="auditAction" size="small">
                <el-radio-button label="pass">审核通过</el-radio-button>
                <el-radio-button label="reject">审核驳回</el-radio-button>
              </el-radio-group>

              <!-- 通过：填写商户号和密钥 -->
              <div v-if="auditAction === 'pass'" class="audit-form">
                <el-form-item label="商户号" required>
                  <el-input v-model="auditForm.wechat_merchant_no" placeholder="请输入微信商户号" />
                </el-form-item>
                <el-form-item label="商户密钥" required>
                  <el-input v-model="auditForm.wechat_merchant_secret" placeholder="请输入商户密钥" type="textarea" :rows="2" />
                </el-form-item>
              </div>

              <!-- 驳回：填写原因 -->
              <div v-if="auditAction === 'reject'" class="audit-form">
                <el-form-item label="驳回原因" required>
                  <el-input v-model="auditForm.reject_reason" placeholder="请填写驳回原因" type="textarea" :rows="3" />
                </el-form-item>
              </div>
            </div>
          </template>
        </el-form>
      </div>

      <span slot="footer">
        <el-button @click="detailVisible = false">关闭</el-button>
        <el-button
          v-if="detail.status === 0"
          type="primary"
          :loading="submitLoading"
          @click="submitAudit"
        >提交审核</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { getMerchantList, auditMerchant } from '@/api/index'

export default {
  name: 'MerchantAudit',
  data() {
    return {
      list: [],
      total: 0,
      page: 1,
      pageSize: 20,
      filterStatus: '',
      loading: false,
      detailVisible: false,
      detail: {},
      auditAction: 'pass',
      auditForm: {
        wechat_merchant_no: '',
        wechat_merchant_secret: '',
        reject_reason: ''
      },
      submitLoading: false
    }
  },
  created() {
    this.fetchList()
  },
  methods: {
    async fetchList() {
      this.loading = true
      try {
        const params = { page: this.page, limit: this.pageSize }
        if (this.filterStatus !== '') {
          params.status = this.filterStatus
        }
        const res = await getMerchantList(params)
        this.list = res.data || []
        this.total = res.total || 0
      } catch (e) {
        this.$message.error('获取列表失败')
      }
      this.loading = false
    },
    handleDetail(row) {
      this.detail = { ...row }
      this.auditAction = 'pass'
      this.auditForm = {
        wechat_merchant_no: '',
        wechat_merchant_secret: '',
        reject_reason: ''
      }
      this.detailVisible = true
    },
    async submitAudit() {
      if (this.auditAction === 'pass') {
        if (!this.auditForm.wechat_merchant_no) {
          this.$message.warning('请填写商户号')
          return
        }
        if (!this.auditForm.wechat_merchant_secret) {
          this.$message.warning('请填写商户密钥')
          return
        }
      } else {
        if (!this.auditForm.reject_reason) {
          this.$message.warning('请填写驳回原因')
          return
        }
      }
      this.submitLoading = true
      try {
        const status = this.auditAction === 'pass' ? 1 : 2
        const params = { id: this.detail.id, status }
        if (status === 1) {
          params.wechat_merchant_no = this.auditForm.wechat_merchant_no
          params.wechat_merchant_secret = this.auditForm.wechat_merchant_secret
        } else {
          params.reject_reason = this.auditForm.reject_reason
        }
        await auditMerchant(params)
        this.$message.success(this.auditAction === 'pass' ? '审核通过' : '已驳回')
        this.detailVisible = false
        this.fetchList()
      } catch (e) {
        this.$message.error('操作失败')
      }
      this.submitLoading = false
    },
    downloadImage(url, name) {
      if (!url) return
      // 通过 fetch 获取图片并触发下载
      fetch(url)
        .then(res => res.blob())
        .then(blob => {
          const a = document.createElement('a')
          a.href = URL.createObjectURL(blob)
          const ext = url.split('.').pop().split('?')[0] || 'jpg'
          a.download = `${name}.${ext}`
          document.body.appendChild(a)
          a.click()
          document.body.removeChild(a)
          URL.revokeObjectURL(a.href)
        })
        .catch(() => {
          // 跨域fallback：直接打开新窗口
          window.open(url, '_blank')
        })
    }
  }
}
</script>

<style scoped>
.merchant-audit {
  padding: 20px;
}

.filter-bar {
  display: flex;
  align-items: center;
  margin-bottom: 16px;
}

.filter-label {
  font-size: 14px;
  color: #606266;
  margin-right: 12px;
}

.pagination-wrap {
  margin-top: 20px;
  text-align: right;
}

.detail-content {
  max-height: 65vh;
  overflow-y: auto;
  padding-right: 10px;
}

.no-data {
  color: #C0C4CC;
  font-size: 13px;
}

.audit-actions {
  margin-top: 10px;
}

.audit-form {
  margin-top: 16px;
  padding: 16px;
  background: #f5f7fa;
  border-radius: 4px;
}

.image-row {
  display: flex;
  align-items: flex-start;
  gap: 12px;
}

.image-row .el-button {
  margin-top: 4px;
}
</style>
